import * as colors from "../../styles/colors";
import * as docketPropTypes from "../../docketPropTypes";
import Button from "../Button";
import LoaderButton from "../LoaderButton";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import TextButton from "../TextButton";
import { StyleSheet, css } from "aphrodite";

const styles = StyleSheet.create({
	dialogFooter: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		paddingBottom: 12,
		paddingTop: 16,
	},
	submit: {
		boxShadow: "none",
		backgroundColor: colors.docketLightGreen6,
	},
	spacer: {
		flex: "1 0 auto",
	},
});

const strings = {
	close: "Close",
	submit: "Submit",
};

export default class DialogFooter extends PureComponent {
	static propTypes = {
		aStyles: docketPropTypes.aphroditeStyles,
		aStylesSubmit: docketPropTypes.aphroditeStyles,
		aStylesSubmitDisabled: docketPropTypes.aphroditeStyles,
		children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
		closeText: PropTypes.string.isRequired,
		handleClose: PropTypes.func,
		handleSubmit: PropTypes.func,
		submitDisabled: PropTypes.bool.isRequired,
		submitHref: PropTypes.string,
		submitLoading: PropTypes.bool.isRequired,
		submitText: PropTypes.string.isRequired,
		submitTo: PropTypes.string,
	};

	static defaultProps = {
		closeText: strings.close,
		submitDisabled: false,
		submitLoading: false,
		submitText: strings.submit,
	};

	_renderClose = () => {
		return <TextButton onClick={this.props.handleClose}>{this.props.closeText}</TextButton>;
	};

	_renderSubmit = () => {
		if (this.props.submitTo) {
			return (
				<Button
					aStyles={[styles.submit, this.props.aStylesSubmit]}
					aStylesDisabled={this.props.aStylesSubmitDisabled}
					disabled={this.props.submitLoading || this.props.submitDisabled}
					floating={true}
					onClick={this.props.handleSubmit}
					to={this.props.submitTo}
				>
					{this.props.submitText}
				</Button>
			);
		}

		return (
			<LoaderButton
				aStyles={[styles.submit, this.props.aStylesSubmit]}
				aStylesDisabled={this.props.aStylesSubmitDisabled}
				disabled={this.props.submitLoading || this.props.submitDisabled}
				floating={true}
				href={this.props.submitHref ? this.props.submitHref : null}
				loading={this.props.submitLoading}
				onClick={this.props.handleSubmit}
			>
				{this.props.submitText}
			</LoaderButton>
		);
	};

	render() {
		return (
			<div className={css(styles.dialogFooter, this.props.aStyles)}>
				{this.props.handleClose ? this._renderClose() : null}
				<div className={css(styles.spacer)} />
				{this.props.children}
				{this.props.handleSubmit || this.props.submitHref || this.props.submitTo
					? this._renderSubmit()
					: null}
			</div>
		);
	}
}
